module.exports = __webpack_public_path__ + "static/media/NETJE ONDER BLAUW.c53c7647.png";